import { getCountries } from "country-state-picker";

function summaryHTML(payload) {

    var html =

        `
    <!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
    <html lang="en">
      <head>
        <meta content="text/html; charset=UTF-8" http-equiv="Content-Type" />
        <meta content="width=device-width, initial-scale=1, maximum-scale=1" name="viewport" />

        <!-- So that mobile will display zoomed in -->
        <meta content="IE=edge" http-equiv="X-UA-Compatible" />

        <!-- enable media queries for windows phone 8 -->
        <meta content="telephone=no" name="format-detection" />
        <meta name="x-apple-disable-message-reformatting" />

        <!-- disable auto telephone linking in iOS -->
        <link href="https://fonts.googleapis.com/css?family=Roboto:400,500,700,900" rel="stylesheet" />

        <!--[if (mso)]> <style type="text/css">     a {text-decoration: none;}     body, table, td, a {font-family: Arial, Helvetica, sans-serif !important;} </style> <![endif]-->
        <style type="text/css">
          @import url("https://use.typekit.net/vwm1etp.css");
          /* What it does: Stops email clients resizing small text. */
          * {
            -ms-text-size-adjust: 100%;
            -webkit-text-size-adjust: 100%;
          }
          /* What it does: Stops Outlook from adding extra spacing to tables. */
          table,
          td {
            mso-table-lspace: 0pt !important;
            mso-table-rspace: 0pt !important;
          }
          img {
            -ms-interpolation-mode: bicubic;
          }
          .btn-primary:hover {
            background-color: #c74e4b !important;
          }
          html,
          body {
            background: #f8f8f8;
            line-height: 18px;
          }
          a {
            text-decoration: none !important;
          }
          table,
          table td {
            border-collapse: collapse;
            border-spacing: 0;
          }
          .td-full-width {
            width: 100% !important;
            max-width: 100% !important;
          }
          .btnhover,
          .btnhovergreen,
          .btnhoverred {
            display: block !important;
          }
          .btnhover:hover {
            border-color: #cdcdcd !important;
            color: #333 !important;
            background-color: #f8f8f8 !important;
          }
          .btnhovergreen:hover {
            background-color: #5c9557 !important;
          }
          .btnhoverred:hover {
            background-color: #c74e4b !important;
          }
          .remove-blue a,
          .remove-blue {
            color: #777 !important;
            text-decoration: none !important;
            cursor: default !important;
          }
          .remove-blue-bk a,
          .remove-blue-bk {
            color: #333 !important;
            text-decoration: none !important;
            cursor: default !important;
          }
          .link-policy {
            color: #777 !important;
            text-decoration: underline !important;
            cursor: pointer !important;
          }
          .blue-link {
            color: #2a90d6 !important;
            text-decoration: underline !important;
            cursor: pointer !important;
          }
          .rm-hover-color {
            color: #777 !important;
            text-decoration: none !important;
          }
          .rm-hover-color-black {
            color: #333 !important;
            text-decoration: none !important;
          }
          .rm-hover-color-white {
            color: #fff !important;
            text-decoration: none !important;
          }
          .out-ul {
            color: #777 !important;
            text-decoration: underline !important;
            cursor: pointer !important;
          }
          .rm-hover-color-ul {
            color: #777 !important;
            text-decoration: underline !important;
          }
          .rm-hover-blue-ul {
            color: #2a90d6 !important;
            text-decoration: underline !important;
          }
          .rm-hover-blue {
            color: #2a90d6 !important;
            text-decoration: none !important;
          }
          .remove-blue-out a {
            color: #333 !important;
            text-decoration: none !important;
          }
          @media screen and (max-width: 767px) {
            table tbody {
              width: 100% !important;
              display: table;
            }
            body {
              margin: 0 auto !important;
            }
            .force-row,
            .container {
              width: 100% !important;
              max-width: 100% !important;
            }
            .force-row1 {
              width: 100% !important;
              max-width: 100% !important;
              float: none !important;
              text-align: center !important;
              display: block !important;
            }
            .width100 {
              width: 100% !important;
              max-width: 100% !important;
            }
            .padding0 {
              padding: 0 !important;
            }
            .img-full-width {
              width: 100% !important;
              max-width: 100% !important;
              border-radius: 0 !important;
            }
            .align-left {
              text-align: left !important;
            }
            .padding10 {
              padding: 15px 0px !important;
            }
            .tbl-center {
              margin: 0 auto !important;
            }
            .padding15-bottom {
              padding-bottom: 15px;
            }
            .padding15-top {
              padding-top: 15px;
            }
            .text-heading-large {
              font-size: 24px !important;
              line-height: 36px !important;
              text-align: center;
            }
            .btnhover,
            .btnhovergreen,
            .btnhoverred {
              max-width: 100% !important;
            }
            .text-subtitle {
              font-size: 18px !important;
              line-height: 26px !important;
            }
            .paddinglr10 {
              padding-left: 15px !important;
              padding-right: 15px !important;
            }
          }
          @media screen and (max-width: 499px) {
            .receipt-content,
            .footer-content {
              padding-left: 16px !important;
              padding-right: 16px !important;
            }
          }
        </style>
      </head>
      <body style="margin: 0px; padding: 0px; background: none 0% 0% repeat scroll #f8f8f8;">
        <style type="text/css">
          @media screen and (max-width: 767px) {
            table tbody {
              width: 100% !important;
              display: table;
            }
            body {
              margin: 0 auto !important;
            }
            .force-row,
            .container {
              width: 100% !important;
              max-width: 100% !important;
            }
            .width100 {
              width: 100% !important;
              max-width: 100% !important;
            }
            .padding0 {
              padding: 0 !important;
            }
            .img-full-width {
              width: 100% !important;
              max-width: 100% !important;
              border-radius: 0 !important;
            }
            .align-left {
              text-align: left !important;
            }
            .padding15-top {
              padding-top: 15px;
            }
            .text-heading-large {
              font-size: 24px !important;
              line-height: 36px !important;
              text-align: center;
            }
            .text-sub-head {
              font-size: 20px !important;
              line-height: 28px !important;
              text-align: center;
            }
            .tablewidth90 {
              width: 90% !important;
            }
            .tdblock {
              width: 100% !important;
              display: block !important;
            }
            .btnhover,
            .btnhovergreen,
            .btnhoverred {
              max-width: 100% !important;
            }
            .text-subtitle {
              font-size: 18px !important;
              line-height: 26px !important;
            }
            .paddinglr10 {
              padding-left: 15px !important;
              padding-right: 15px !important;
            }
          }
          @media screen and (max-width: 499px) {
            .receipt-content,
            .footer-content {
              padding-left: 16px !important;
              padding-right: 16px !important;
            }
          }
        </style>
        <table style="border-collapse: collapse; margin: 0px auto;" width="100%" cellspacing="0" cellpadding="0" border="0">
          <tbody>
            <tr>
              <td style="background: none 0% 0% repeat scroll #f8f8f8; padding: 32px 20px 20px;" valign="top" align="center">
                <table style="border-collapse: collapse; margin: 0px auto;" width="100%" cellspacing="0" cellpadding="0" border="0">
                  <tbody>
                    <tr>
                      <td>
                        <table style="background: none 0% 0% repeat scroll #ffffff; border-collapse: collapse; max-width: 650px; margin: 0px auto; border-radius: 12px; box-shadow: rgba(51, 51, 51, 0.02) 0px 0px 8px 0px;" class="container" width="100%" cellspacing="0" cellpadding="0" border="0" align="center">
                          <tbody>
                            <tr>
                              <td style="padding: 20px 0px 28px;" valign="top" align="center">
                                <table style="border-collapse: collapse; margin: 0px auto;" width="100%" cellspacing="0" cellpadding="0" border="0">
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table class='tablewidth90' style='border-collapse: collapse; margin:0 auto;' width='85%' cellspacing='0' cellpadding='0' border='0' align='center'>
                                          <tbody>
                                            <tr>
                                              <td style='text-align: center;'><a href='https://evolugy.com'> <img alt='' src='https://dev.evolugy.com/logo.png' style='max-width:100%; width:50px; -moz-border-radius: 5px; -webkit-border-radius: 5px; border-radius: 5px;' width='180' /></a></td>
                                            </tr>
                                            <tr>
                                              <td style='padding:8px 0px 20px; text-align: center;border-bottom:1px solid #e7e7e7;'><a style='color: #333; font-family:proxima-nova, Roboto, Helvetica, Arial; font-size: 20px; line-height: 24px; font-weight: 500; text-decoration:none'><span class='rm-hover-color-black'>Resumen de consulta con ${payload.doctor_name}</span></a></td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <table class="tablewidth90" style="border-collapse: collapse; margin: 0px auto;" width="85%" cellspacing="0" cellpadding="0" border="0" align="center">
                                          <tbody>
                                            <tr>
                                              <td style="text-align: center;" align="center">
                                                <table cellspacing='0' cellpadding='0' border='0' width='100%' style='border-collapse: collapse; margin:0 auto;'>
                                                  <tbody>
                                                    <tr>
                                                      <td style='padding-bottom:4px;'>
                                                        <table cellspacing='0' cellpadding='0' width='100%' border='0' style='border-collapse: collapse; margin: 0 auto;'>
                                                          <tbody>
                                                            <tr>
                                                                <td style='text-align: center;padding-top:10px;'><a href='https://evolugy.com'>
                                                                <img alt='' src='https://firebasestorage.googleapis.com/v0/b/evolugy2020.appspot.com/o/1.png?alt=media&token=ef1546a6-11ad-4e6c-90ea-47243029f5ff' 
                                                                style='max-width:100%; width:300px; -moz-border-radius: 5px; -webkit-border-radius: 5px; border-radius: 5px;' width='180' /></a></td>
                                                            </tr>
                                                            <tr>
                                                              <td style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 16px; line-height: 20px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:400'>
                                                                <span class='remove-blue-out'>Estimado/a ${payload.patient_name}</span>
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 16px; line-height: 20px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:400'>
                                                                <span class='remove-blue-out'>Gracias por su asistencia a la consulta con <strong> ${payload.doctor_name} </strong> </span>
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 16px; line-height: 20px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:400'>
                                                                <span class='remove-blue-out'>
                                                                  <strong>Usted es muy importante para nosotros </strong>, y nuestro objetivo es atenderlo de la mejor manera posible siempre,
                                                                  así como mejorar constantementa, por ello, <strong> le pedimos que nos ayude contestando la encuesta de satisfacción.</strong>
                                                                </span>
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td style='color: #777; font-size: 16px; line-height: 22px; text-align: center; font-family:proxima-nova,Roboto, Helvetica, Arial;'>
                                                                Puedes agendar una nueva consulta en el siguiente enlace: 
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="padding: 24px 0px 0px;">
                                                <table style="border-collapse: collapse; margin: 0px auto; max-width: 430px;" class="force-row1" width="100%" cellspacing="0" cellpadding="0" border="0" align="center">
                                                  <tbody>
                                                    <tr>
                                                      <td style="text-align: center;">
                                                        <table border="0" width="100%" align="center" cellpadding="0" cellspacing="0" style="border-collapse:collapse;">                                                                                                      <tr><td valign="top" style=" text-align:center;" >
                                                        <table style="border-collapse: collapse; display: inline-block; vertical-align: top;" class="force-row1" width="168" cellspacing="0" cellpadding="0" border="0">
                                                          <tbody>
                                                            <tr>
                                                              <td style="padding-left: 5px; padding-bottom: 15px; padding-right: 5px;">
                                                                <table class="width100" style="border-collapse: collapse;" width="165" cellspacing="0" cellpadding="0" border="0" align="center">
                                                                  <tbody>
                                                                    <tr >
                                                                      <td style="min-width: 100%; padding: 15px 0px; text-align: center; font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; color: #ffffff; background-color: #003057; border-radius: 3px; text-decoration: none; transition: background-color 200ms ease 0s, border 200ms ease 0s, color 200ms ease 0s, box-shadow 300ms ease 0s; display: block;" align="center"> <a style='font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; color: #ffffff; text-decoration: none; display: block; line-height: 18px;' href="https://app.evolugy.com/links/consultation-request/${payload.patient_id}/${payload.doctor_id}"><span class='rm-hover-color-white'>Nueva consulta</span></a> </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td> </td>
                                            </tr>

                                            <tr>
                                              <td>
                                                <table width='100%' cellspacing='0' cellpadding='0' border='0' style='border-collapse: collapse;'>
                                                  <tr>
                                                    <td style='padding-top:17px;padding-bottom:15px;'>
                                                      <table width='100%' cellspacing='0' cellpadding='0' border='0' style='border-collapse: collapse;min-width:100%;'>
                                                        <tr>
                                                          <td style='padding:24px 39px 0px;border-top: 1px solid #e7e7e7; text-align: center; color: #333333; font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; font-weight: 600; line-height: 24px;'>Resumen de consulta</td>
                                                        </tr>
                                                        <tr style="display: none;">
                                                          <td style="padding: 17px 0px 0px;">
                                                            <table style="border-collapse: collapse;" width="100%" cellspacing="0" cellpadding="0" border="0">
                                                              <tbody>
                                                                <tr>
                                                                  <td style="text-align:center;"> <img src='http://evolugy.com/wp-content/uploads/2018/10/summary.png' alt='' width='50%'> </td>
                                                                </tr>
                                                              </tbody>
                                                            </table>
                                                          </td>
                                                        </tr>
                                                        <tr>
                                                          <td style='text-align: center; padding-bottom:20px;color: #777777; font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; line-height: 24px; font-weight: 400;'> A continuación podrás leer un resumen del diagnóstico del Dr. ${payload.doctor_name}</td>
                                                        </tr>
                                                        <tr >
                                                          <table border="0" cellpadding="0" cellspacing="0" width="95%" class="dataTable" >
                                                            <tr>
                                                              <th colspan="2" style="padding:7px 10px;text-transform:uppercase;border-bottom:3px solid #111 ;font-family:Helvetica;font-size:110%;font-weight:bold;line-height:150%;text-align:left;padding-bottom:4px ;padding-left:0;">Consulta #${payload.consultation_id}</th>
                                                            </tr>
                                                            ${payload.event.meta.cie10 ? payload.event.meta.cie10.map(function (element) {
                                                              return `
                                                                    <tr><td valign="top" width="25%" class="tableLabel" style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 18px; line-height: 22px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'><span class='remove-blue-out'>
                                                                      CIE-10</span>
                                                                    </td>
                                                                    <td colspan="2" valign="top" width="75%" class="content" style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 18px; line-height: 22px; text-align: right; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'><span class='remove-blue-out'>
                                                                      <strong>${element.c}: ${element.d}</strong></span>
                                                                    </td></tr>
                                                                    `;
                                                            }).join('') : ''}
                                                            ${ false ?
                                                            `<tr>
                                                            <td valign="top" width="25%" class="tableLabel " style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 18px; line-height: 22px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'><span class='remove-blue-out'>
                                                              Motivo de Consulta</span>
                                                            </td>
                                                              <td colspan="2" valign="top" width="75%" class="content" style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 14px; line-height: 22px; text-align: right; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'>
                                                                <span class='remove-blue-out'>
                                                                  ${payload.event.meta.comments_obs ? payload.event.meta.comments_obs : ''}
                                                                </span>
                                                              </td>
                                                            </tr>` : ``}
                                                            <tr>
                                                              <td valign="top" width="25%" class="tableLabel " style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 18px; line-height: 22px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'><span class='remove-blue-out'>
                                                                Evaluación</span>
                                                              </td>
                                                              <td colspan="2" valign="top" width="75%" class="content" style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 14px; line-height: 22px; text-align: right; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'>
                                                                <span class='remove-blue-out'>
                                                                  ${payload.event.meta.diagnosis_eval ? payload.event.meta.diagnosis_eval : '' }
                                                                </span>
                                                              </td>
                                                            </tr>
                                                            <tr>
                                                              <td valign="top" width="25%" class="tableLabel " style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 18px; line-height: 22px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'><span class='remove-blue-out'>
                                                                Examen Físico</span>
                                                              </td>
                                                              <td colspan="2" valign="top" width="75%" class="content" style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 14px; line-height: 22px; text-align: right; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'><span class='remove-blue-out'>
                                                                ${payload.event.meta.physical_exam ? payload.event.meta.physical_exam : ''}</span>
                                                              </td>
                                                            </tr>
                                                          </table>

                                                        </tr>
                                                          <tr >
                                                            <table border="0" cellpadding="0" cellspacing="0" width="95%" class="dataTable" >
                                                              ${payload.event.meta.prescription_id ? 
                                                              `<tr >
                                                                <td valign="top" width="50%" class="tableLabel" style='padding-bottom:41px; padding-top:16px; color: #333; font-size: 18px; line-height: 22px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'><span class='remove-blue-out'>
                                                                  Receta: </span>
                                                                </td>
                                                                <td style="max-width: 60%; padding: 15px 0px; text-align: center; font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; color: #ffffff; background-color: #00a0df; border-radius: 3px; text-decoration: none; transition: background-color 200ms ease 0s, border 200ms ease 0s, color 200ms ease 0s, box-shadow 300ms ease 0s; display: block;" align="center">
                                                                <a style='font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; color: #ffffff; text-decoration: none; display: block; line-height: 18px;' 
                                                                href="https://app.evolugy.com/links/recipe/view/${payload.doctor_id}/${payload.event.meta.prescription_id}">
                                                                <span class='rm-hover-color-white'>Ver</span></a> </td>
                                                              </tr>`
                                                              : ''}
                                                              ${payload.event.meta.exam_id ? 
                                                              `<tr>
                                                                <td valign="top" width="50%" class="tableLabel" style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 18px; line-height: 22px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'>
                                                                <span class='remove-blue-out'>
                                                                  Solicitud de exámenes: </span>
                                                                </td>

                                                                <td style="max-width: 60%; padding: 15px 0px; text-align: center; font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; color: #ffffff; background-color: #00a0df; border-radius: 3px; text-decoration: none; transition: background-color 200ms ease 0s, border 200ms ease 0s, color 200ms ease 0s, box-shadow 300ms ease 0s; display: block;" align="center">
                                                                <a style='font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; color: #ffffff; text-decoration: none; display: block; line-height: 18px;' 
                                                                href="https://app.evolugy.com/links/exam/view/${payload.doctor_id}/${payload.event.meta.exam_id}"><span class='rm-hover-color-white'>Ver</span></a> </td>
                                                              </tr>` : ''
                                                              }
                                                              <tr>
                                                              <td valign="top" width="25%" class="tableLabel " style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 18px; line-height: 22px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'><span class='remove-blue-out'>
                                                                Evaluación</span>
                                                              </td>
                                                              <td colspan="2" valign="top" width="75%" class="content" style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 14px; line-height: 22px; text-align: right; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'>
                                                                <span class='remove-blue-out'>
                                                                  ${payload.instructions ? payload.instructions : '' }
                                                                </span>
                                                              </td>
                                                            </tr>
                                                            </table>

                                                          </tr>
                                                        
                                                      </table>
                                                    </td>
                                                  </tr>
                                                </table>
                                              </td>
                                            </tr>

                                            <tr>
                                              <td>
                                                <table width='100%' cellspacing='0' cellpadding='0' border='0' style='border-collapse: collapse;'>
                                                  <tr>
                                                    <td style='padding-top:17px;padding-bottom:15px;'>
                                                      <table width='100%' cellspacing='0' cellpadding='0' border='0' style='border-collapse: collapse;min-width:100%;'>
                                                        <tr>
                                                          <td style='padding:24px 39px 0px;border-top: 1px solid #e7e7e7; text-align: center; color: #333333; font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; font-weight: 600; line-height: 24px;'>
                                                            Contesta nuestra encuesta de satisfacción: </td>
                                                        </tr>
                                                        <tr >
                                                          <td style="margin-left: 10px; margin-right:10px; min-width: 90%; padding: 15px 0px; text-align: center; font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; color: #ffffff; background-color: #00a0df; 
                                                            border-radius: 3px; text-decoration: none; transition: background-color 200ms ease 0s, border 200ms ease 0s, color 200ms ease 0s, box-shadow 300ms ease 0s; display: block;" align="center">
                                                            <a style='font-family: proxima-nova, Roboto, Helvetica, Arial; font-size: 16px; color: #ffffff; text-decoration: none; display: block; line-height: 18px;' href="https://app.evolugy.com/links/consultation-review/${payload.consultation_id}">
                                                              <span class='rm-hover-color-white'>Contestar</span>
                                                            </a>
                                                          </td>
                                                        </tr>
                                                      </table>
                                                    </td>
                                                  </tr>
                                                </table>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>

                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

          </tbody>
        </table>
      </body>
    </html>

    `
  return html;  
}

function getCIE(payload){
  var cie_html = ``;
  return new Promise((resolve, reject) => {
    if(payload.event.meta.cie10 && payload.event.meta.cie10.lenght > 0){
      payload.event.meta.cie10.forEach((element, index, arr) => {
        cie_html += `
        <tr><td valign="top" width="25%" class="tableLabel" style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 18px; line-height: 22px; text-align: left; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'><span class='remove-blue-out'>
          CIE-10</span>
        </td>
        <td colspan="2" valign="top" width="75%" class="content" style='padding-bottom:4px; padding-top:16px; color: #333; font-size: 18px; line-height: 22px; text-align: right; font-family:proxima-nova, Roboto, Helvetica, Arial; font-weight:600'><span class='remove-blue-out'>
          <strong>${element.c}: ${element.d}</strong></span>
        </td></tr>
        `;
        if(index == arr.lenght-1){
          resolve(cie_html);
        }
      });
    } else {
      resolve('');
    }
  });
    
}

export {summaryHTML};